import React, { useEffect } from 'react';

const SmartsupChat = () => {
  useEffect(() => {
    const smartsupp = document.createElement('script');
    smartsupp.type = 'text/javascript';
    smartsupp.async = true;
    smartsupp.src = 'https://www.smartsuppchat.com/loader.js?';
    document.body.appendChild(smartsupp);

    window._smartsupp = window._smartsupp || {};
    window._smartsupp.key ="43b8b5c7ba68f954013d4d7275552bfd28cc72a3"

    return () => {
      document.body.removeChild(smartsupp);
    };
  }, []);

  return <></>; // Ensures the component returns something
};

export default SmartsupChat;

